<template>
    <div v-if="list && list.length > 0" class="container">
        <h2>{{ title }}</h2>
        <div class="delivery-options">
            <div v-for="item in list" class="item">
                <header>
                    <span class="icon-wrap" v-html="item.icon"></span>
                    <h3>{{ item.title }}</h3>
                </header>

                <div class="content" v-html="item.description"></div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .delivery-options p {
        color: var(--color-gray-dark-content);
    }

    @media (min-width: 768px) {
        .delivery-options p + p:before {
            content: '';
            display: block;
            position: relative;
            width: 16px;
            height: 2px;
            background: var(--color-gray-dark-content);
            margin: 20px 0 10px;
        }
    }
</style>

<style lang="scss" scoped>
    h2, h3, p {
        color: var(--color-gray-dark-content);
    }

    h2 {
        font-size: 2.4rem;
    }

    .item {
        margin-top: 32px;

        & + .item {
            margin-top: 48px;
        }
    }

    header {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 16px;

        h3 {
            font-size: 1.7rem;
            margin-left: .5rem;

        }
    }

    .icon-wrap {
        position: relative;

        &:before {
            content: "";
            position: absolute;
            left: -20%;
            top: -20%;
            width: 100%;
            height: 0;
            padding-top: 0;
            padding-bottom: 100%;
            min-width: 27px;
            background: rgba(var(--color-purple-darker-rgb), .1);
            z-index: 0;
            border-radius: 10px;
        }
    }

    .content {
        font-size: 1.2rem;
        color: var(--color-gray-dark-content);

        p + p {
            margin-top: 1.5rem;
        }
    }

    @media (min-width: 768px) {
        h2 {
            margin-top: 1rem;
            margin-bottom: 3rem;
        }

        .delivery-options {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-top: 32px;

            .item {
                margin-top: 0;
                width: calc(50% - 15px);
            }

            .content {
                text-align: left;
            }
        }
    }

    @media (min-width: 992px) {
        .delivery-options {
            .item {
                width: calc(50% - 30px);
            }
        }
    }
</style>

<script>
    export default {
        props: {
            title: String,
            list: {
                type: Array,
                required: true,
            },
        },
    }
</script>
